<div class="chart-detail-container">
  <div class="filters-section">
    <div class="filters-grid">
      <div class="filter-item">
        <label>Start Date:</label>
        <p-calendar 
          [(ngModel)]="startDate" 
          dateFormat="yy-mm-dd"
          [showIcon]="true"
          placeholder="Select start date"
          [maxDate]="endDate || undefined">
        </p-calendar>
      </div>
      <div class="filter-item">
        <label>End Date:</label>
        <p-calendar 
          [(ngModel)]="endDate" 
          dateFormat="yy-mm-dd"
          [showIcon]="true"
          placeholder="Select end date"
          [minDate]="startDate || undefined">
        </p-calendar>
      </div>
      <div class="filter-item filter-actions">
        <button pButton type="button" label="Apply" 
          icon="pi pi-filter"
          (click)="applyFilters()" 
          [disabled]="isLoading"
          class="p-button-sm p-button-success">
        </button>
        <button pButton type="button" label="Clear" 
          icon="pi pi-times"
          (click)="clearFilters()" 
          [disabled]="isLoading || !filtersApplied"
          class="p-button-sm p-button-secondary">
        </button>
      </div>
    </div>
    
    <div class="filter-status-bar" *ngIf="filtersApplied">
      <i class="pi pi-filter-fill"></i>
      <span>{{ startDate | date:'mediumDate' }} - {{ endDate | date:'mediumDate' }}</span>
      <span class="item-count">{{ totalItemsAfterFilter }} items</span>
    </div>
    
    <div class="loading-indicator" *ngIf="isLoading">
      <i class="pi pi-spin pi-spinner"></i> Loading...
    </div>
  </div>

  <div class="chart-section">
    <div class="date-range-banner compact" *ngIf="filtersApplied">
      <i class="pi pi-calendar"></i>
      <span>Filtered: {{ startDate | date:'MMM d, y' }} - {{ endDate | date:'MMM d, y' }} ({{ totalItemsAfterFilter }} items)</span>
    </div>
    
    <div class="date-range-banner compact all-data" *ngIf="!filtersApplied">
      <i class="pi pi-database"></i>
      <span>All Data ({{ totalItemsBeforeFilter }} items)</span>
    </div>
    
    <div class="chart-title">
      <h4>{{ config.data.costType | titlecase }} Price Distribution</h4>
    </div>
    <div style="display: block; height: 350px;">
      <canvas
        baseChart
        [type]="config.data.chartType"
        [data]="chartData"
        [options]="config.data.chartOptions">
      </canvas>
    </div>
  </div>
  
  <div class="stats-section" *ngIf="config.data.rawData">
    <h4>Statistics</h4>
    <div class="stats-grid">
      <div class="stat-item">
        <label>Total Items:</label>
        <span>{{ config.data.fullData?.count || config.data.rawData.length }}</span>
      </div>
      <div class="stat-item" *ngIf="config.data.rawData[0]?.count !== undefined">
        <label>Total Count:</label>
        <span>{{ getTotalCount() }}</span>
      </div>
      <div class="stat-item" *ngIf="config.data.rawData[0]?.binStart !== undefined">
        <label>Range:</label>
        <span>{{ getRange() }}</span>
      </div>
      <div class="stat-item" *ngIf="config.data.fullData?.mean !== undefined">
        <label>Mean:</label>
        <span>{{ config.data.fullData.mean }}</span>
      </div>
      <div class="stat-item" *ngIf="config.data.fullData?.median !== undefined">
        <label>Median:</label>
        <span>{{ config.data.fullData.median }}</span>
      </div>
      <div class="stat-item" *ngIf="config.data.fullData?.stdDev !== undefined">
        <label>Std Dev:</label>
        <span>{{ config.data.fullData.stdDev }}</span>
      </div>
      <div class="stat-item" *ngIf="config.data.fullData?.skewness !== undefined">
        <label>Skewness:</label>
        <span>{{ config.data.fullData.skewness }}</span>
      </div>
    </div>
    
    <!-- Temporal Statistics -->
    <div class="temporal-stats" *ngIf="config.data.fullData?.temporalStats">
      <h5>Temporal Distribution</h5>
      <div class="monthly-breakdown">
        <div class="month-item" *ngFor="let month of config.data.fullData.temporalStats.monthlyBreakdown">
          <span class="month-label">{{ month.monthName }}</span>
          <div class="month-bar">
            <div class="month-bar-fill" [style.width.%]="month.percentage"></div>
          </div>
          <span class="month-stats">{{ month.count }} ({{ month.percentage }}%)</span>
        </div>
      </div>
    </div>
    
    <h5>Data Breakdown</h5>
    <div class="data-table">
      <div class="table-header">
        <span>Range</span>
        <span>Count</span>
        <span>Percentage</span>
      </div>
      <div class="table-row" *ngFor="let item of config.data.rawData">
        <span>{{ item.binStart }}-{{ item.binEnd }}</span>
        <span>{{ item.count }}</span>
        <span>{{ item.percentage }}%</span>
      </div>
    </div>
  </div>
</div>